// -----------------------------------------------------------------
// JavaScript for Card Grid Editor
// -----------------------------------------------------------------

TECL_Card = {

    // Initialise grid editor widget specific scripts
    Initialise: function() {
        $(".card.match-height").matchHeight();
    }

};
